import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import { buttonHtml } from './buttonHtml'
import { addClassToAll, sweetAlertCommonParams } from '../../functions/utils'

export const buttonModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.button_modal_title,
    html: buttonHtml,

    willOpen: () => {
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_dropdown_postback',
        dataType: 'JSON',
        data: { page_table_id, instagram_bot_addon },
        success:function(response) {
          $("#button-type-postback").html(response.dropdown_str);
          $('#button-type-postback').val(oldData.value || '').trigger('change')
        }
      })

      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const buttonText = $('#button-button-text')
      const buttonType = $('#button-button-type')

      const postBackType = $('#button-type-postback')
      const postBackTypeGroup = $('#button-type-postback-group')

      const webUrlType = $('#button-type-weburl')
      const webUrlTypeGroup = $('#button-type-weburl-group')

      const callType = $('#button-type-call')
      const callTypeGroup = $('#button-type-call-group')

      const webviewType = $('#button-type-webview')
      const webviewTypeGroup = $('#button-type-webview-group')

      // Sets old data it there is any
      buttonText.val(oldData.buttonText || '')
      buttonType.val(oldData.buttonType || '').trigger('change')

      addClassToAll('d-none', '.button-onDemand-field')

      switch (buttonType.val()) {
        case 'post_back':
          postBackType.val(oldData.value || '').trigger('change')
          postBackTypeGroup.removeClass('d-none')
          break
        case 'web_url':
          webUrlType.val(oldData.value || '')
          webUrlTypeGroup.removeClass('d-none')
          break        
        case 'phone_number':
          callType.val(oldData.value || '')
          callTypeGroup.removeClass('d-none')
          break        
        case 'web_url_full': 
        case 'web_url_compact':
        case 'web_url_tall':
          webviewType.val(oldData.value || '')
          webviewTypeGroup.removeClass('d-none')
          break
        default:        
          break
      }

      buttonType.on('change', function(e) {
        const selectedType = e.target.value

        addClassToAll('d-none', '.button-onDemand-field')

        if ('post_back' === selectedType) {
          postBackTypeGroup.removeClass('d-none')
        } else if ('web_url' === selectedType) {
          webUrlTypeGroup.removeClass('d-none')
        } else if ('phone_number' === selectedType) {
          callTypeGroup.removeClass('d-none')
        } else if (
          [
            'web_url_full',
            'web_url_compact',
            'web_url_tall',
          ].indexOf(selectedType) > -1
        ) {
          webviewTypeGroup.removeClass('d-none')
        }
      })
    },

    preConfirm: () => {
      const buttonText = $('#button-button-text').val()
      const buttonType = $('#button-button-type').val()

      if (! buttonText) {
        Swal.showValidationMessage(lang.button_modal_msg_button_name)
        return
      }

      if (! buttonType) {
        Swal.showValidationMessage(lang.button_modal_msg_button_type)
        return
      }

      const data = {
        buttonText: buttonText,
        buttonType: buttonType,
        text: $('#button-button-type option:selected').text()
      }

      if ('post_back' === buttonType) {
        const postbackId = $('#button-type-postback')
        if (! postbackId.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_postback_id)
          return
        }
        data.value = postbackId.val()
        data.postback_text = $('#button-type-postback option:selected').text()
      } else if ('web_url' === buttonType) {
        const webUrl = $('#button-type-weburl')
        if (! webUrl.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_web_url)
          return
        }        
        data.value = webUrl.val()
        
      } else if (
        [
          'web_url_full', 
          'web_url_compact', 
          'web_url_tall',
        ].indexOf(buttonType) > -1
      ) {
        const webviewUrl = $('#button-type-webview')
        if (! webviewUrl.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_webview_url)
          return
        }         
        data.value = webviewUrl.val()
      } else if ('phone_number' === buttonType) {
        const callUs = $('#button-type-call')
        if (! callUs.val()) {
          Swal.showValidationMessage(lang.button_modal_msg_mobile)
          return
        } 
        data.value = callUs.val()
      } else {
        const buttonTypeText = $('#button-button-type option:selected').text()
        data.text = buttonTypeText
      }

      return data
    },    
  })
}